exports = module.exports = require("../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#player[data-v-4dcd32ae]{width:100vw;height:5.6266rem\n}\n@media(min-width: 600px){\n#player[data-v-4dcd32ae]{width:100%;height:680px;-o-object-fit:contain;object-fit:contain;background:#000\n}\n}\n.error[data-v-4dcd32ae]{width:100vw;height:5.6266rem;background:#000;padding-top:2rem\n}\n.error p[data-v-4dcd32ae]{color:#fff;text-align:center;font-size:.32rem\n}\n.error p[data-v-4dcd32ae]:last-child{color:#027cfa;font-size:.4rem;letter-spacing:.05rem;border:1px solid #027cfa;width:2.2rem;margin:0 auto;padding:.05rem;margin-top:.5rem\n}", ""]);

// exports
